import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import id from "./id.json";
import en from "./en.json";

const DICT = { id, en };
const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem("aurora_locale");
    if (saved === "id" || saved === "en") return saved;
    // Auto-detect browser locale: non-Indonesian → default to English
    const nav = (navigator.language || navigator.userLanguage || "id").toLowerCase();
    return nav.startsWith("id") ? "id" : "en";
  });

  useEffect(() => {
    localStorage.setItem("aurora_locale", locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const t = useCallback(
    (key, fallback = "") => {
      const parts = key.split(".");
      let cur = DICT[locale] || DICT.id;
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return fallback || key;
      }
      return typeof cur === "string" ? cur : fallback || key;
    },
    [locale]
  );

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext) || { locale: "id", setLocale: () => {}, t: (k, f) => f || k };
